




























































import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown} from 'element-ui'
import Vue from 'vue'
import { Component, Watch, Mixins, Ref, Prop } from 'vue-property-decorator';
import { Prescription, RefillStatusCode } from "@/models/Prescription";

@Component({
  name: 'RecentScripts',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  }
})
export default class RecentScripts extends Vue {
  @Prop({default: 9}) itemLimit!:Number;
  
  private recentScripts = new Array<Prescription>();

  mounted() {
    this.loadData();
  }

  loadData(){
    this.axios.get<Array<Prescription>>(`KPI/RecentScripts`)
    .then(res => {
      if(res.data?.length) this.recentScripts = res.data.map(rx => new Prescription(rx));
    });
  }

  statusName(rx:Prescription):string{
    let res = rx.statusName;
    
    if(rx.hasBeenShipped || rx.isShipped) return 'Complete';
    if(rx.isExpired) return res;

    let showAsProcessed = [RefillStatusCode.Refillable,RefillStatusCode.AutoRefillable,RefillStatusCode.NonRefillable,RefillStatusCode.AwaitingInsurance];
    if(showAsProcessed.some(st => st == rx.status)) {
      if (!rx.orderId) return 'Contacting Patient'
      else return "Processed";
    }

    if(rx.status == RefillStatusCode.OnHold) return "Pending";

    return res;
  }

  statusReason(rx:Prescription){
    let statusName = this.statusName(rx);
    if(statusName == 'Processed') {
      if(rx.status == RefillStatusCode.AwaitingInsurance) return rx.statusName;
      else return 'Filling'
    };
    if(statusName == 'Complete') return 'Shipped';
    if(statusName == 'Pending') return rx.subStatusName;

    return '';
  }
  
}
